export default "__VITE_ASSET__BGuDR1yT__"